/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.



/*
 * EXPORTS
 */
export default gql`
query SmsReadLatency($endDate: DateTime!, $startDate: DateTime!, $latencyRanges: [LatencyRangeInput!], $customerAccountId: ID, $vendorNameToSearch: String, $countryNameToSearch: String) {
  SmsReadLatency(endDate: $endDate, startDate: $startDate, latencyRanges: $latencyRanges, customerAccountId: $customerAccountId, vendorNameToSearch: $vendorNameToSearch, countryNameToSearch: $countryNameToSearch) {
    id, 
   _report,
   _reportData,
    message,
    status
  }
}
`
